import { render, staticRenderFns } from "./TailwindSegmentedTabs.vue?vue&type=template&id=e5960892&"
import script from "./TailwindSegmentedTabs.vue?vue&type=script&lang=ts&"
export * from "./TailwindSegmentedTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports